// Which day a message belongs to, in the reader's own timezone (the browser's local time). The labels
// are Russian like the rest of the interface, so they are formatted as ru-RU whatever the browser locale
// is -- "Сегодня" next to "12 September" would read as two different apps.

const dayFormatter = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });
const yearDayFormatter = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
const stampFormatter = new Intl.DateTimeFormat('ru-RU', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const timeFormatter = new Intl.DateTimeFormat([], { hour: '2-digit', minute: '2-digit' });

// Locale methods returned this string for malformed legacy dates; Intl.format throws.
function format(formatter: Intl.DateTimeFormat, at: Date): string {
  return Number.isNaN(at.getTime()) ? 'Invalid Date' : formatter.format(at);
}
export function messageTime(at: Date): string { return format(timeFormatter, at); }

export function sameDay(a: Date, b: Date): boolean { return a.toDateString() === b.toDateString(); }

// "Сегодня", "Вчера", "12 сентября", or "12 сентября 2025 г." for a past year.
export function dayLabel(at: Date, now: Date = new Date()): string {
  if (sameDay(at, now)) return 'Сегодня';
  const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1);
  if (sameDay(at, yesterday)) return 'Вчера';
  return format(at.getFullYear() === now.getFullYear() ? dayFormatter : yearDayFormatter, at);
}

// The full moment behind a message's "15:47": shown on hover and on long-press.
export function fullStamp(at: Date): string {
  return format(stampFormatter, at);
}
